import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingPoweredByCannyHelmet from 'common/helmets/LandingPoweredByCannyHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';
import Point1 from 'img/landing/feature-request-tracking-1.webp';
import Point3 from 'img/landing/idea-management-1.webp';
import Point2 from 'img/landing/public-roadmap-2-b.webp';

import LandingHero from 'img/new-landing-hero.gif';

import 'css/components/www/_LandingPoweredByCanny.scss';

class LandingPoweredByCanny extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        company: PropTypes.string,
      }),
    }),
    trackEvent: PropTypes.func,
  };

  componentWillMount() {
    const {
      location: { query },
      router,
    } = this.props;
    if (query.company) {
      return;
    }

    router.replace('/');
  }

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Powered by Canny Page');
  }

  render() {
    const {
      location: {
        query: { company },
      },
    } = this.props;
    return (
      <div className="landingPoweredByCanny">
        <LandingPoweredByCannyHelmet />
        <div className="fullWidthContainer">
          <div className="header">
            <div className="text">
              <div className="heading">
                {company} uses Canny to&nbsp;manage customer&nbsp;feedback
              </div>
              <Link className="cta" to="/register">
                <Button buttonType="greenButton" value="TRY CANNY YOURSELF" />
              </Link>
              <span className="meta">Free sign up · No credit card required</span>
            </div>
            <LazyLoadedImage className="landingHero" src={LandingHero} />
          </div>
        </div>
        <div className="mainContentContainer">
          <div className="sectionHeading">How {company} benefits from using&nbsp;Canny</div>

          <div className="points">
            <div className="point">
              <LazyLoadedImage className="pointImg" src={Point1} />
              <div className="text">
                <h2 className="title">Feature voting board</h2>
                <div className="description">
                  Instead of sending users to an email form, {company} users can vote
                  on&nbsp;features.
                </div>
              </div>
              <Link to="/use-cases/feature-request-management">
                See tracking feature requests&nbsp;→
              </Link>
            </div>
            <div className="point">
              <LazyLoadedImage className="pointImg" src={Point2} />
              <div className="text">
                <h2 className="title">Keep everyone in the&nbsp;loop</h2>
                <div className="description">
                  Feedback shouldn't go into a black hole. {company} users like you get updates
                  directly from the&nbsp;team.
                </div>
              </div>
              <Link to="/public-roadmap">See public roadmaps&nbsp;→</Link>
            </div>
            <div className="point">
              <LazyLoadedImage className="pointImg" src={Point3} />
              <div className="text">
                <h2 className="title">One place for all&nbsp;feedback</h2>
                <div className="description">
                  {company} gets valuable insights by having feedback from customers and teammates
                  in a single&nbsp;place.
                </div>
              </div>
              <Link to="/idea-management">See idea management&nbsp;→</Link>
            </div>
          </div>
          <LandingFooterCTA style="solid" expanded={true} title="Try Canny for your product" />
        </div>
      </div>
    );
  }
}

export default withContexts({ trackEvent: TrackEventContext })(LandingPoweredByCanny);
